import { getCookie } from 'bv';
import format from './format';

const getCurrencyPart = (part) => () => {
  const cookieVal = getCookie(`currency_${part}`);

  return cookieVal ? decodeURIComponent(cookieVal) : '';
};

const suffix = getCurrencyPart('suffix');
const prefix = getCurrencyPart('prefix');

export default (amount) => (
  `${prefix()}${format(amount)}${suffix()}`
);
